import { styled } from '@mui/system';
import { Typography } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up(768)]: {
    flexDirection: 'row',
  },
  width: '100%',
  zIndex: 1000,
}));

export const InfoRightContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  [theme.breakpoints.up(768)]: {
    flex: '1 0 50%',
    maxWidth: '50%',
    paddingLeft: '24px',
  },
}));

export const ContentContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

export const ProductDataContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
}));

export const OneLineText = styled(Typography)({
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
});

export const ProductName = styled(OneLineText)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 600,
  lineHeight: '32px',
  color: theme.palette.text.primary,
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  whiteSpace: 'normal',
}));

export const ActivePrinciple = styled(OneLineText)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 400,
  color: theme.palette.text.secondary,
}));

export const Concentration = styled(OneLineText)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 400,
  color: theme.palette.text.secondary,
}));

export const PriceContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginTop: '2px',
  color: theme.palette.text.secondary,
}));

export const Price = styled(OneLineText)(({ theme }) => ({
  fontSize: '22px',
  color: theme.palette.text.primary,
  fontWeight: 600,
}));

export const AveragePrice = styled(OneLineText)(({ theme }) => ({
  fontSize: '13px',
  color: theme.palette.text.secondary,
  fontWeight: 400,
}));

export const BaseSpan = styled('span')({
  display: 'block',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  color: '#757575',
});

export const LastBuyContainer = styled('div')({
  position: 'absolute',
  top: 15,
  left: 15,
  borderRadius: '100px',
  border: '0.8px solid #CBCBCB',
  backgroundColor: '#F9F9F9',
  padding: '4px 8px',
  zIndex: 1,
});

export const LastBuyText = styled('span')({
  color: '#414046',
  fontFamily: 'Poppins',
  fontSize: '13px',
  fontWeight: '400',
  lineHeight: '19.5px',
});

export const LastBuyTextBold = styled('span')({
  fontWeight: '600',
});

export const DiscountPriceContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
});

export const PricesContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
});

export const DiscountPrice = styled(BaseSpan)(() => ({
  color: '#5D5FEF',
  fontFamily: 'Poppins',
  fontSize: '16px',
  fontWeight: '600',
  lineHeight: '24px',
  letterSpacing: '0.02em',
}));

export const DiscountChip = styled('div')({
  backgroundColor: '#5D5FEF',
  width: '37px',
  height: '18px',
  borderRadius: '100px',
  textAlign: 'center',
  gap: '2px',
  position: 'relative',
  top: '2px',
});

export const DiscountChipTypography = styled(Typography)({
  color: '#FFFFFF',
  fontFamily: 'Poppins',
  fontSize: '12px',
  fontWeight: '400',
  lineHeight: '18px',
  letterSpacing: '-0.01em',
});

export const OriginalPrice = styled(BaseSpan)({
  color: '#CBCBCB',
  textDecoration: 'line-through',
  fontFamily: 'Poppins',
  fontSize: '12px',
  fontWeight: '300',
  lineHeight: '24px',
  letterSpacing: '2%',
});

export const Overlay = styled('div')(({ theme }) => ({
  height: '100%',
  backgroundColor: 'rgba(0,0,0,0.5)',
  zIndex: 1200,
  position: 'fixed',
  bottom: 0,
  width: '100%',
  left: 0,
  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}));
